module.exports = __webpack_public_path__ + "img/alert.695cbf2a.svg";